/**
 * 其他收货人
 */
import {Popover, List, Typography} from "antd";
import Lang from "@components/Lang/Lang";


const OtherConsignee = props => {
    /**
     * 收货人
     * @type {*[]}
     */
    const consignees = props.consignees || [];

    /**
     * 气泡内容
     * @returns {JSX.Element}
     */
    const content = () => {
        return <List
            style={{width: "367px"}}
            header={<h3><Lang id="QiTaShouHuoRenXinXi">其他收货人信息</Lang></h3>}
            dataSource={consignees}
            renderItem={item => (
                <List.Item>
                    {item.consigneeName}&emsp;+{item.telCode} {item.consigneeMonde}
                </List.Item>
            )}
        />
    }

    return <span className="OtherConsignee">
        <Popover placement="topLeft" content={content} trigger="click">{props.children}</Popover>
    </span>
}

export default OtherConsignee;
